import React, { useState, useEffect } from "react";
import {
  Avatar,
  Button,
  Card,
  Checkbox,
  Table,
  Col,
  Dropdown,
  Flex,
  Input,
  List,
  Menu,
  Row,
  Space,
  Form,
  Switch,
  message,
  Segmented,
} from "antd";
import { AppstoreOutlined, BarsOutlined } from "@ant-design/icons";

import { useMutation, useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../services/react-query/queryKeys";
import { getAllLocations } from "../../network/location";
import {
  getTeamMembersLocation,
  updateTeamMemberActiveStatus,
} from "../../network/teamMember";
import { TeamMemberType } from "../../types/teamMember";
import { SearchOutlined, MoreOutlined } from "@ant-design/icons";
import EnvelopeSVG from "../../assets/teamMember/EnvelopeSVG";
import PhoneSVG from "../../assets/teamMember/PhoneSVG";
import ContactsSVG from "../../assets/teamMember/ContactsSVG";
import AddTeamMember from "./creatTeamMember/AddTeamMember";
import { Link } from "react-router-dom";
import DeleteTeamMemeber from "./DeleteTeamMember";
import DeleteTeamMember from "./DeleteTeamMember";
import { ColumnsType } from "antd/es/table";
import { BsPlusSquare } from "react-icons/bs";
import SalonLocationsSelect from "../common/SalonLocationsSelect";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { UserOutlined } from "@ant-design/icons";
import GenderSwitch from "../common/GenderSwitch";
import LocationCheckSVG from "../../assets/teamMember/LocationCheckSVG";
import TimerSVG from "../../assets/teamMember/TimerSVG";
import { Location } from "../../types/location";
import PinSVG from "../../assets/teamMember/PinSVG";
import EditSVG from "../../assets/teamMember/EditSVG";
import { TbTrashX } from "react-icons/tb";
import TMSkeleton from "../admin/common/TMSkeleton";

interface DataType {
  id: string;
  key: any;
  name: string;
  title: string;
  phone: string;
  email: string;
  available_for: string;
  available_work_for: string;
  locations: Location[];
  start_date: string;
  notes: string | null;
  nameString: string;
}

function TeamMemberTable() {
  const intl = useIntl();
  const columns: ColumnsType<DataType> = [
    {
      title: intl.formatMessage({
        id: "memberName",
        defaultMessage: "اسم العضو",
      }),
      dataIndex: "name",
    },
    {
      title: intl.formatMessage({ id: "job", defaultMessage: "الوضيفة" }),
      dataIndex: "title",
    },
    {
      title: intl.formatMessage({
        id: "phoneNumber",
        defaultMessage: "رقم الجوال",
      }),
      dataIndex: "phone",
    },
    {
      title: intl.formatMessage({
        id: "email",
        defaultMessage: "الربيد الاكتروني",
      }),
      dataIndex: "email",
    },
    {
      title: intl.formatMessage({ id: "process", defaultMessage: "العمليات" }),
      dataIndex: "action",
      key: "action",
    },
  ];
  const [teamMemberId, setTeamMemberId] = useState<number | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);
  const [teamMemberData, setTeamMemberData] = useState(null);
  const [selectedTeamMembers, setSelectedTeamMembers] = useState<number[]>([]);
  const [viewMode, setViewMode] = useState("list");
  const [search, setSearch] = useState<string>();

  const { mutate, isLoading } = useMutation(
    (status: boolean) => {
      if (selectedTeamMembers?.length === 0) {
        return false;
      }

      return updateTeamMemberActiveStatus({
        value: status,
        team_members: selectedTeamMembers,
      });
    },
    {
      onSuccess: (res: any) => {
        console.log(res);
        if (res?.code !== "ERR_BAD_REQUEST") {
          refetch();
          message.success(
            intl.formatMessage({
              id: "statusUpdatedSuccessfully",
              defaultMessage: "تم تحديث الحالة بنجاح",
            })
          );
          setSelectedTeamMembers([]);
        } else {
          message.error(res?.response?.data?.message);
        }
      },
    }
  );

  const { data: listLocations } = useQuery([queryKeys.listLocations], () =>
    getAllLocations()
  );

  const [selectedLocation, setSelectedLocation] = useState(listLocations);
  const { locationId } = useSelector(
    (state: { calendar: { locationId: string } }) => state.calendar
  );
  const {
    data: listTeamMember,
    refetch,
    isLoading: isLoadingTMs,
  } = useQuery(
    [queryKeys.listTeamMember, locationId, search],
    () => getTeamMembersLocation(locationId, { search }),
    { enabled: !!locationId }
  );
  const formattedData = listTeamMember?.data?.map((item: any) => ({
    name: (
      <div className="flex gap-2">
        <Checkbox
          onClick={(e) => e.stopPropagation()}
          className="border-spacing-0"
          checked={
            // item?.enable_online_booking === 1 ||
            selectedTeamMembers.includes(item?.id)
          }
          onChange={() => handleChangeSelectTeamMember(item?.id)}
        />
        <span>
          <Avatar
            icon={<UserOutlined />}
            className="bg-gray"
            style={{ height: "48px", width: "48px" }}
            src={item?.media}
          />
          <Link
            to="/team-member/data"
            state={{ team_member_data: item }}
            // className="flex flex-col md:flex-row gap-2"
          >
            <span className="pr-2 text-[#00086D]">{item?.name}</span>
          </Link>
        </span>
      </div>
    ),
    phone: (
      <div className="text-[#9999A7] text-sm font-medium">{item?.phone}</div>
    ),
    email: <div className="text-[#9999A7]">{item?.email}</div>,
    title: (
      <div className="text-[#9999A7] text-sm font-medium">{item?.title}</div>
    ),

    key: item.id,
    available_work_for: item?.available_work_for,
    available_for: item?.available_for,
    locations: item?.locations,
    start_date: item?.start_date,
    notes: item?.notes,
    nameString: item?.name,
  }));

  useEffect(() => {
    if (listLocations?.data?.length > 0) {
      setSelectedLocation(listLocations.data[0].id);
    }
  }, [listLocations]);

  const openModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setTeamMemberId(null);
  };

  const openModalDelete = (modal: any, teamMemeberData: any) => {
    setIsModalDeleteVisible(true);
    setTeamMemberData(teamMemeberData);
  };
  const onChangeSwitch = (e: boolean) => {
    mutate(e);
  };
  const handleChangeSelectTeamMember = (id: number) => {
    if (selectedTeamMembers.includes(id)) {
      setSelectedTeamMembers(selectedTeamMembers.filter((item) => item !== id));
    } else {
      setSelectedTeamMembers([...selectedTeamMembers, id]);
    }
  };
  return (
    <>
      <div className="mb-3 flex flex-col-reverse  md:flex-row items-center gap-2  md:justify-between">
        <SalonLocationsSelect />

        <Link
          to="/settings/team-member-settings"
          className="  flex items-center justify-center px-3 py-2 text-center bg-[#EEF0FF] rounded-lg gap-2"
        >
          <span className="flex items-center justify-center font-semibold text-sm">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className=""
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00082 2.05265L6.52562 3.57898C6.36861 3.74144 6.15235 3.83318 5.92642 3.83318H3.83416V5.92544C3.83416 6.15138 3.74242 6.36763 3.57996 6.52465L2.05362 7.99985L3.57996 9.47505C3.74242 9.63207 3.83416 9.84832 3.83416 10.0743V12.1665H5.92642C6.15235 12.1665 6.36861 12.2583 6.52562 12.4207L8.00082 13.947L9.47602 12.4207C9.63304 12.2583 9.84929 12.1665 10.0752 12.1665H12.1675V10.0743C12.1675 9.84832 12.2592 9.63206 12.4217 9.47505L13.948 7.99985L12.4217 6.52465C12.2592 6.36763 12.1675 6.15138 12.1675 5.92544V3.83318H10.0752C9.84929 3.83318 9.63304 3.74144 9.47602 3.57898L8.00082 2.05265ZM7.40161 1.23369C7.72919 0.894758 8.27245 0.894759 8.60003 1.23369L10.1459 2.83318H12.3342C12.7944 2.83318 13.1675 3.20628 13.1675 3.66651V5.85474L14.767 7.40064C15.1059 7.72822 15.1059 8.27148 14.767 8.59906L13.1675 10.145V12.3332C13.1675 12.7934 12.7944 13.1665 12.3342 13.1665H10.1459L8.60003 14.766C8.27245 15.1049 7.72919 15.1049 7.40161 14.766L5.85571 13.1665H3.66749C3.20725 13.1665 2.83416 12.7934 2.83416 12.3332V10.145L1.23467 8.59906C0.895736 8.27148 0.895735 7.72822 1.23467 7.40064L2.83416 5.85474V3.66651C2.83416 3.20628 3.20725 2.83318 3.66749 2.83318H5.85571L7.40161 1.23369Z"
                fill="#00086D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.83416 7.99985C4.83416 6.25095 6.25192 4.83318 8.00082 4.83318C9.74973 4.83318 11.1675 6.25095 11.1675 7.99985C11.1675 9.74875 9.74973 11.1665 8.00082 11.1665C6.25192 11.1665 4.83416 9.74875 4.83416 7.99985ZM8.00082 5.83318C6.80421 5.83318 5.83416 6.80323 5.83416 7.99985C5.83416 9.19647 6.80421 10.1665 8.00082 10.1665C9.19744 10.1665 10.1675 9.19647 10.1675 7.99985C10.1675 6.80323 9.19744 5.83318 8.00082 5.83318Z"
                fill="#00086D"
              />
            </svg>
          </span>
          <span className="font-semibold text-sm">
            {intl.formatMessage({
              id: "teamMemberSettings",
              defaultMessage: "إعدادات فريق العمل",
            })}
          </span>
        </Link>
      </div>
      <Card className="p-2">
        <Row
          gutter={{ xs: 8, sm: 16, md: 8, lg: 14, xl: 10 }}
          justify={"space-between"}
        >
          <Col className="gutter-row mb-1 text-sm mt-4">
            <span className="text-[#00086D]">
              ({selectedTeamMembers?.length})
            </span>
            <span className="text-gray-400 px-1">
              {intl.formatMessage({
                id: "selected",
                defaultMessage: "تم تحديد",
              })}
            </span>
          </Col>

          <Col className="gutter-row mb-1">
            <Row
              gutter={{ xs: 8, sm: 16, md: 8, lg: 14, xl: 10 }}
              justify={"space-between"}
            >
              <Col>
                <Form.Item
                  name="calendar_booking"
                  className="float-left"
                  rules={[{ required: true, message: "صفقة جديدة مطلوب" }]}
                >
                  <Switch
                    disabled={isLoading || selectedTeamMembers?.length === 0}
                    className="custom-switch-text"
                    onChange={onChangeSwitch}
                    checkedChildren={
                      <span style={{ color: "#00086D" }}>
                        {intl.formatMessage({
                          id: "bookingWithTeamMemeberEnabled",
                          defaultMessage: "الحجز مع العضو مفعل",
                        })}
                      </span>
                    }
                    unCheckedChildren={
                      <span style={{ color: "gray" }}>
                        {intl.formatMessage({
                          id: "bookingWithTeamMemeberDisabled",
                          defaultMessage: "الحجز مع العضو غير مفعل",
                        })}
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
              <Col>
                <Segmented
                  onChange={(view: string) => {
                    setViewMode(view);
                  }}
                  value={viewMode}
                  options={[
                    {
                      value: "page",
                      icon: <BarsOutlined />,
                    },
                    {
                      value: "list",
                      icon: <AppstoreOutlined />,
                    },
                  ]}
                />
              </Col>

              <div className="m-2 md:m-0 flex justify-center  items-center md:items-start  flex-col-reverse md:flex-row gap-2">
                <Col className="gutter-row ">
                  <Input
                    onChange={(e: any) => {
                      setSearch(e.target.value);
                    }}
                    placeholder={intl.formatMessage({
                      id: "searchTeamMember",
                      defaultMessage: "ابحث عن عضو معين..",
                    })}
                    prefix={<SearchOutlined />}
                    className=" text-gray-400"
                  />
                </Col>

                <Col className="">
                  <Button
                    type="primary"
                    onClick={openModal}
                    icon={<BsPlusSquare />}
                  >
                    {intl.formatMessage({
                      id: "addTeamMember",
                      defaultMessage: "أضف عضو جديد",
                    })}
                  </Button>
                </Col>
              </div>
            </Row>
          </Col>
        </Row>

        {isModalVisible && (
          <AddTeamMember
            visible={true}
            onClose={closeModal}
            config={{
              locationId: selectedLocation,
              isEdit: !!teamMemberId,
              teamMemberId: !!teamMemberId ? teamMemberId : undefined,
            }}
          />
        )}

        {isModalDeleteVisible && (
          <DeleteTeamMember
            visible={isModalDeleteVisible}
            onClose={() => setIsModalDeleteVisible(false)}
            teamMemeberData={teamMemberData}
          />
        )}
        {isLoadingTMs ? (
          <div className="flex  gap-4 flex-wrap justify-center">
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <TMSkeleton />
            ))}
          </div>
        ) : viewMode === "list" ? (
          <List
            grid={{
              gutter: 14,
              xs: 1,
              sm: 2,
              md: 2,
              lg: 3,
              xl: 3,
              xxl: 4,
            }}
            loading={isLoadingTMs}
            className="mt-4"
            dataSource={listTeamMember?.data}
            renderItem={(item: TeamMemberType, index) => (
              <List.Item
                style={{
                  boxShadow: " 0px 2px 14px 0px rgba(156, 171, 194, 0.24)",
                  padding: "10px",
                }}
                className="rounded-md p-4"
              >
                <div className="flex justify-between gap-2 ">
                  <Checkbox
                    checked={selectedTeamMembers.includes(item?.id)}
                    onChange={() => handleChangeSelectTeamMember(item?.id)}
                  />
                  <Dropdown
                    className=""
                    overlay={
                      <Menu>
                        <Menu.Item
                          key="edit"
                          onClick={() => {
                            setTeamMemberId(item?.id);
                            setIsModalVisible(true);
                          }}
                        >
                          {intl.formatMessage({
                            id: "edit",
                            defaultMessage: "تعديل",
                          })}
                        </Menu.Item>
                        <Menu.Item
                          key="delete"
                          onClick={() =>
                            openModalDelete(DeleteTeamMemeber, item)
                          }
                        >
                          {intl.formatMessage({
                            id: "delete",
                            defaultMessage: "مسح",
                          })}
                        </Menu.Item>
                      </Menu>
                    }
                  >
                    <Button className="border-none bg-transparent shadow-none outline-none hover:none">
                      <Space>
                        <MoreOutlined />
                      </Space>
                    </Button>
                  </Dropdown>
                </div>
                <div className="">
                  <Link
                    to="/team-member/data"
                    state={{ team_member_data: item }}
                    // className="flex flex-col md:flex-row gap-2"
                  >
                    <div className="overflow-auto p-2 flex flex-col md:flex-row gap-3 items-center justify-center ">
                      <div>
                        <Avatar
                          icon={<UserOutlined />}
                          className="bg-gray"
                          size={72}
                          src={item?.media}
                        />
                      </div>

                      <div className="flex flex-col   gap-1 items-center text-[#75757E]  ">
                        <p className="text-[18px] text-black ">{item?.name}</p>

                        <div className=" flex gap-2 items-center text-[14px] ">
                          <p className=" ">
                            <ContactsSVG />
                          </p>
                          <p className="px-1 ">{item?.title}</p>
                        </div>
                        {item?.phone ? (
                          <div className="flex gap-2 items-center text-[14px]">
                            <p className="">
                              <PhoneSVG />
                            </p>
                            <p className="px-1" dir="ltr">
                              {item?.phone}
                            </p>
                          </div>
                        ) : null}
                        {item?.email ? (
                          <div className="flex max-sm:flex-wrap gap-2 items-center text-[14px] ">
                            <p className="">
                              <EnvelopeSVG />
                            </p>
                            <p className=" ">
                              <p className="">{item?.email}</p>
                            </p>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </Link>
                </div>
              </List.Item>
            )}
          />
        ) : (
          <div className="customTable customWhiteTable shadow rounded-md overflow-auto">
            <Table
              className=""
              columns={columns}
              rowClassName={() => " customTableRow  shadow rounded-md "}
              expandable={{
                expandRowByClick: true,
                expandedRowRender: (record) => (
                  <div className="bg-[#EEF0FF] p-2">
                    <div className="flex flex-col md:flex-row gap-2 justify-between my-4">
                      <div>
                        <p className="flex gap-1 ms-4">
                          <span>
                            {intl.formatMessage({
                              id: "about",
                              defaultMessage: "عن",
                            })}
                          </span>
                          <span>{record?.nameString}</span>
                        </p>
                      </div>
                      <div className=" flex  gap-2">
                        <Link
                          to="/team-member/data"
                          state={{
                            team_member_data: {
                              name: record?.nameString,
                              id: record?.key,
                              editMode: true,
                            },
                          }}
                        >
                          <Button
                            type="default"
                            className="h-10 w-[150px]"
                            icon={<EditSVG />}
                          >
                            {intl.formatMessage({
                              id: "edit",
                              defaultMessage: "تعديل",
                            })}
                          </Button>
                        </Link>
                        <Button
                          type="primary"
                          className="h-10 w-[150px]"
                          danger
                          onClick={() =>
                            openModalDelete(DeleteTeamMemeber, {
                              id: record?.key,
                            })
                          }
                          icon={<TbTrashX size={20} />}
                        >
                          {intl.formatMessage({
                            id: "deleteMember",
                            defaultMessage: "حذف العضو",
                          })}
                        </Button>
                      </div>
                    </div>

                    <div>
                      {record?.locations.map(
                        (location: Location, i: number) => (
                          <div
                            key={i}
                            className="mb-3 bg-white rounded-md p-2 shadow"
                          >
                            <div className="flex flex-col md:flex-row justify-center items-center gap-2 md:justify-between">
                              <Flex justify="flex-start">
                                <div className="text-color-gray text-base font-normal">
                                  <TimerSVG />{" "}
                                  {intl.formatMessage({
                                    id: "startDate",
                                    defaultMessage: "تاريخ البدء",
                                  })}
                                  :
                                </div>
                                <div className="mx-2">{record?.start_date}</div>
                              </Flex>

                              <Flex justify="flex-end">
                                <div className="text-color-gray text-base font-normal">
                                  <LocationCheckSVG />{" "}
                                  {intl.formatMessage({
                                    id: "theBranch",
                                    defaultMessage: "الفرع",
                                  })}
                                  :
                                </div>
                                <div className="mx-2">{location?.name}</div>
                              </Flex>
                            </div>
                          </div>
                        )
                      )}
                      <div className="mb-3 bg-white shadow rounded-md p-2">
                        <Flex justify="flex-start">
                          <div className="text-color-gray text-base font-normal flex gap-1 items-center">
                            <PinSVG />
                            {intl.formatMessage({
                              id: "notes",
                              defaultMessage: "ملاحظات",
                            })}
                            <span>:</span>
                            <p className="text-black">{record?.notes || ""}</p>
                          </div>
                        </Flex>
                      </div>
                    </div>
                    <Row
                      gutter={{ xs: 8, sm: 16, md: 8, lg: 14, xl: 10 }}
                      className="mb-4"
                    >
                      <Col className="pt-2">
                        {intl.formatMessage({
                          id: "availableOnline",
                          defaultMessage: "الاتاحة اونلاين",
                        })}
                        :
                      </Col>
                      <Col>
                        <Form.Item name="enable_gift_card">
                          <Switch
                            className="custom-switch-text"
                            checkedChildren={
                              <span style={{ color: "#00086D" }}>
                                {" "}
                                {intl.formatMessage({
                                  id: "shown",
                                  defaultMessage: "معروضة",
                                })}
                              </span>
                            }
                            unCheckedChildren={
                              <span style={{ color: "gray" }}>
                                {" "}
                                {intl.formatMessage({
                                  id: "notShown",
                                  defaultMessage: " غير معروضة",
                                })}
                              </span>
                            }
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col className="pt-2">
                        {intl.formatMessage({
                          id: "availableFor",
                          defaultMessage: "الاتاحة لـ",
                        })}{" "}
                        :
                      </Col>
                      <Col>
                        <GenderSwitch
                          disabled
                          active={true}
                          gender={
                            record?.available_work_for === "man"
                              ? "man"
                              : record?.available_work_for === "woman"
                              ? "woman"
                              : "both"
                          }
                          string={intl.formatMessage({
                            id: record?.available_work_for,
                            defaultMessage: record?.available_work_for,
                          })}
                        />
                      </Col>
                    </Row>
                  </div>
                ),
                rowExpandable: (record) => record.id !== "Not Expandable",
              }}
              dataSource={formattedData}
            />
          </div>
        )}
      </Card>
    </>
  );
}

export default TeamMemberTable;
